import { createDropdownSelect } from '@flipster/react/design-system/dropdown/dropdown-select';
import { useBreakpoint } from '@flipster/react/misc/responsive';

type StatusValue = 'true' | 'all';

const DropdownSelect = createDropdownSelect<StatusValue>();

const items: { label: string; value: StatusValue }[] = [
  { label: 'All status', value: 'all' },
  { label: 'Filled', value: 'true' },
];

interface OrderStatusSelectBoxProps {
  value: string | undefined;
  onChange: (value: string | undefined) => void;
}

export const OrderStatusSelectBox = ({ value, onChange }: OrderStatusSelectBoxProps) => {
  const { isMobile } = useBreakpoint();
  const selected = (value ?? 'all') as StatusValue;

  if (isMobile) return null;

  return (
    <DropdownSelect.Root
      selected={selected}
      onChange={(v) => {
        onChange(v === 'all' ? undefined : v);
      }}
    >
      <DropdownSelect.TriggerChip type='square' />
      <DropdownSelect.Select>
        {items.map((item) => (
          <DropdownSelect.Item key={item.value} value={item.value} label={item.label} />
        ))}
      </DropdownSelect.Select>
    </DropdownSelect.Root>
  );
};
